import React from "react";
import ac1 from "../../static/a3.webp";
import hasanImg from "../../static/hasanImg.jpeg";

export default function CureentOpenings() {
  const email = "career@imanhasan-ca.com";

  return (
    <>
      <div className="h-24 overflow-x-hidden bg-berry">
        <h2
          className="text-center text-white my-4 overline text-xl lg:text-3xl"
          data-aos="zoom-in"
          data-aos-delay="50"
          data-aos-duration="1000"
        >
          Current openings
        </h2>
      </div>

      <div className="flex items-center justify-center bg-berry drop-shadow-lg">
        <div className="w-5/6 sm:w-3/4 md:w-2/3 lg:w-2/3 xl:w-2/3 bg-berry rounded-lg mt-4 mb-4">
          <figure className="bg-berry">
            <img
              className="rounded-lg w-full my-3"
              src={hasanImg}
              alt="image description"
              data-aos="zoom-out"
              data-aos-delay="50"
              data-aos-duration="1000"
            />

            <figcaption className="px-4 pb-6 text-lg text-white">
              <p
                className="text-2xl font-semibold"
                data-aos="zoom-in-up"
                data-aos-delay="50"
                data-aos-duration="1000"
              >
                Current Vacancies: Trainee Student
              </p>

              <p
                className="text-xl my-2"
                data-aos="zoom-in"
                data-aos-delay="50"
                data-aos-duration="1000"
              >
                Please Email Your CV at :
                <a
                  href={`mailto:${email}`}
                  className="hover:underline hover:text-cyan ml-1"
                >
                  {email}
                </a>
              </p>
            </figcaption>
          </figure>
        </div>
      </div>
    </>
  );
}